import { CreateInvoiceInput } from '__generated__/GQL';
import { InvoiceFormSchema } from 'features/Work/form/invoiceForm.schema';
import { formatInvoiceTask } from 'features/Work/utils/formatInvoiceTask';

export const formatCreateMutationInput = (
  invoice: InvoiceFormSchema,
): CreateInvoiceInput => {
  const sortedTasksWithoutTotals = invoice.tasks.map(formatInvoiceTask);

  return {
    allowCreditCardPayment: invoice.allowCreditCardPayment,
    allowIbanPayment: invoice.allowIbanPayment,
    clientId: invoice.clientId,
    companyProfileId: invoice.companyProfileId,
    currency: invoice.currency,
    fiscalId: invoice.fiscalId,
    lateFeePercentage: invoice.lateFeePercentage,
    lateMaxDays: invoice.lateMaxDays,
    settings: {
      issuerEmail: invoice.settings.issuerEmail,
      legalMentions: invoice.settings.legalMentions,
    },
    startAt: invoice.startAt,
    subtitle: invoice.subtitle,
    tasks: sortedTasksWithoutTotals,
    title: invoice.title,
  };
};
